import { render, staticRenderFns } from "./InterestedEvents.vue?vue&type=template&id=61de9d94&"
import script from "./InterestedEvents.vue?vue&type=script&lang=js&"
export * from "./InterestedEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports